import React, {useEffect, useState} from "react";
import Layout from "../components/utils/layout";
import Workload from "./charts/workload";
import Formatters from "../components/utils/formatters";


const Home = () => {

    const screenId = "Home"
    const formatters = Formatters()
    const charts = {
        // workload : {
        //     source:"jira",
        //     specialFormatters: {
        //         timeleft:   formatters.secondsToHours,
        //         timetotal:  formatters.secondsToHours,
        //         progress:   formatters.progressPercent,
        //         key:        formatters.jira_link
        //     }
        // }
    }
    const [workloadData, setWorkloadData] = useState('')
    const onDataChanged = (chartName, event) => {
        if(chartName === 'workload' && event) setWorkloadData(event)
    }

    return <Layout prefsPrefix={screenId} items={charts} onDataChanged={onDataChanged}>
        {/*<Workload data={workloadData}/>*/}
    </Layout>
}

export default Home
